.root {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3) var(--space-5);
  /* Side padding keeps the summary and page buttons off the edges of a flush table card. */
  padding: var(--space-3) var(--space-4);
  border-top: 1px solid var(--color-border);
  font-size: var(--font-size-sm);
}

.summary {
  color: var(--color-text-muted);
  font-variant-numeric: tabular-nums;
}

.controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3) var(--space-5);
}

.pageSize {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
}

.pageSizeLabel {
  color: var(--color-text-muted);
  white-space: nowrap;
}

.select {
  height: var(--layout-control-height-sm);
  padding: 0 var(--space-2);
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-md);
  background-color: var(--color-surface);
  color: var(--color-text);
  font-size: var(--font-size-sm);
  font-variant-numeric: tabular-nums;
}

.pages {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  margin: 0;
  padding: 0;
  list-style: none;
}

.pageButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: var(--layout-control-height-sm);
  height: var(--layout-control-height-sm);
  padding: 0 var(--space-2);
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  color: var(--color-text-muted);
  font-weight: var(--font-weight-medium);
  font-variant-numeric: tabular-nums;
}

.pageButton:hover:not(:disabled) {
  background-color: var(--color-surface-hover);
  color: var(--color-text);
}

.pageButton:disabled {
  opacity: 0.45;
}

.stepButton {
  border-color: var(--color-border-strong);
  background-color: var(--color-surface);
}

.current,
.current:hover:not(:disabled) {
  border-color: var(--color-primary);
  background-color: var(--color-primary-subtle);
  color: var(--color-link);
  font-weight: var(--font-weight-semibold);
}

.ellipsis {
  display: inline-flex;
  justify-content: center;
  min-width: 1.5rem;
  color: var(--color-text-subtle);
}

.compactStatus {
  display: none;
  padding: 0 var(--space-2);
  color: var(--color-text-muted);
  font-variant-numeric: tabular-nums;
}

@media (max-width: 560px) {
  .pageNumberItem {
    display: none;
  }

  .compactStatus {
    display: inline-flex;
  }
}
